export const create = {
  form: {
    code: 'Code',
    name: 'Name',
    type: 'Type',
    submit: 'Submit',
    select: 'Select',
    shortName: 'Short Name',
    requireCode: 'Please input customer code',
    requireName: 'Please input customer name',
    requireShortName: 'Please input customer short name',
    requireType: 'Please input customer type',
  },
  pageHeader: {
    title: 'New Customer',
    back: 'Back',
  },
}
